<div class="tw-flex tw-items-center tw-justify-between">
  <span class="section-header">{{ header }}</span>
  <span class="tw-text-xs tw-font-medium tw-leading-[125%] tw-tracking-[0.005em]">
    {{ headerDescription }}
  </span>
</div>
